export enum ActionCardAlign {
    LEFT,
    RIGHT,
    TOP,
    BOTTOM
}
